export default __webpack_public_path__ + "static/media/Conscript's Armguards of Dynastic Rule.d0108234.jpg";